<div class="wrapper theme2">

  <div class="block-content">
    <div>
      <app-public-menu></app-public-menu>
      <div class="relative header-slider-wrapper animate animation-duration-1000 animation-ease-out">
        <div class="card">
            <p-card class="building-item col-12 md:col-6">
                <div class="grid">
                <app-loader [loading]="loadingProperty"></app-loader>
                <div class="col-12" *ngIf="!loadingProperty">
                    <app-property-gallery [property]="property"></app-property-gallery>
                </div>
                <div class="col-12 md:col-6"></div>
                </div>
                <p class="orange">
                    <i class="pi pi-map-marker"></i>{{property.location}} <strong>{{property.rooms}} Habitaciones {{property.bathrooms}} baños</strong>
                </p>
            </p-card>
            <p-card class="detail" header="{{property.name}}" subheader="{{property.total_investment | number: '2.2' }} €" class="building-item col-12 md:col-6">
                <p class="detail-p">
                Periódo de inversión <strong>{{property.investment_time}} años</strong>
                </p>
                <p class="detail-p">
                Rentabilidad total estimada <strong>{{property.total_return}}%</strong>
                </p>
                <p class="detail-p">
                Rentabilidad anual alquiler <strong>{{property.annual_rent_return}}%</strong>
                </p>
                <!-- <p class="detail-p">
                Inicio Renta <strong>27/03/2024</strong>

                </p> -->
                <p class="detail-p-des">
                Descripción
                </p>
                <p id="parsedDescriptionId" class="detail-p-html">
                </p>
                <ng-template pTemplate="footer">
                <div class="progress blue" *ngIf="property.state == 'studying'">
                    <p class="location ">
                        <i class="pi pi-question"></i>En Estudio
                    </p>
                    <p-progressBar  mode="indeterminate" [style]="{'height': '12px'}"></p-progressBar>
                </div>
                <div class="progress green" *ngIf="property.state == 'in_progress'">
                    <p class="location ">
                        <i class="pi pi-check"></i>En Progreso
                    </p>
                    <p-progressBar mode="indeterminate" [style]="{'height': '12px'}"></p-progressBar>
                </div>
                <div class="progress red" *ngIf="property.state == 'finished'">
                    <p class="location ">
                        <i class="pi pi-flag-fill"></i>Finalizado
                    </p>
                    <p-progressBar value="100" [style]="{'height': '12px'}"></p-progressBar>
                </div>
                </ng-template>
            </p-card>
        </div>
      </div>
      <div class="google-map" leaveClass="fadeinright" [hidden]="false">
        <div class="mapouter"><div class="gmap_canvas"><iframe width="820" height="560" id="gmap_canvas" src="https://maps.google.com/maps?q=plaza+donantes+gijon&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://textcaseconvert.com/"></a><br><a href="https://online-timer.me/"></a><br><style>.mapouter{position: relative;text-align: right;height: 560px;width: 820px;}</style><a href="https://www.embedmaps.co">google satellite maps zoom</a><style>.gmap_canvas{overflow: hidden;background: none !important;height: 560px;width: 820px;}</style></div></div>
      </div>
      <div leaveClass="fadeinright" [hidden]="false"
        class="feature-wrapper full-width grey relative animation-duration-1000 animation-ease-out">
        <div class="container">
          <div leaveClass="fadeinright" [hidden]="false"
            class="feature-wrapper full-width grey relative animation-duration-1000 animation-ease-out interesting">
            <app-loader [loading]="loadingProperties"></app-loader>
            <div class="container" *ngIf="!loadingProperties && propertyList">
              <div class="container-outstanding mt-3">
                <div class="text-6xl font-bold text-center text-gradient title-outstanding">Inmuebles Relacionados</div>
                <app-loader [loading]="loadingProperties"></app-loader>
                <div class="outstanding-data">
                  <p-carousel [value]="propertyList" [numVisible]="4" [numScroll]="1"
                    [responsiveOptions]="responsiveOptions">
                    <ng-template let-property pTemplate="item">
                      <div class="product-item">
                        <div class="product-item-content">
                          <app-property-card [property]="property" [config]="{type: 'public'}"></app-property-card>
                        </div>
                      </div>
                    </ng-template>
                  </p-carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!----><!---->
      </div>
    </div>

    <app-public-footer></app-public-footer>
